import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { TUI_DARK_MODE } from '@taiga-ui/core/tokens';

import { syncLegacyDarkTheme } from '@common/utils/theme';
import { WebsocketService } from '@services/websocket.service';
import { getCurrentUser } from '@store/actions/current_user.actions';
import { getDeviceModels } from '@store/deviceModels/device_models.actions';

import { environment } from '../../environments/environment';
import { MobileHeaderService } from '../mobile/services/mobile-header.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.less'],
  host: {
    '(document:keydown.escape)': 'onEscape()',
  },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MainComponent implements OnInit, OnDestroy {
  private readonly night = inject(TUI_DARK_MODE);
  private readonly store = inject(Store);
  private readonly websocketService = inject(WebsocketService);
  protected readonly mobileHeader = inject(MobileHeaderService);

  readonly isProductionMode = environment.production;

  expandState = false;
  isMobileMenuOpen = false;

  @ViewChild('mobileMenuButton')
  private mobileMenuButton?: ElementRef<HTMLButtonElement>;

  constructor() {
    syncLegacyDarkTheme(this.night);
  }

  ngOnInit() {
    const sessionStorageToken = sessionStorage.getItem(environment.tokenKey);

    if (!sessionStorageToken) {
      sessionStorage.removeItem(environment.tokenKey);
      window.location.href = '/';
    }

    this.store.dispatch(getCurrentUser());
    this.store.dispatch(getDeviceModels());
  }

  changeSidebarState($event: any) {
    this.expandState = $event;
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen ? this.closeMobileMenu() : this.openMobileMenu();
  }

  openMobileMenu(): void {
    this.isMobileMenuOpen = true;
  }

  closeMobileMenu(restoreFocus = true): void {
    if (!this.isMobileMenuOpen) {
      return;
    }

    this.isMobileMenuOpen = false;

    if (restoreFocus) {
      requestAnimationFrame(() => this.mobileMenuButton?.nativeElement.focus());
    }
  }

  onEscape(): void {
    this.closeMobileMenu();
  }

  ngOnDestroy() {
    sessionStorage.clear();
    this.websocketService.disconnectUserSocket();
  }
}
